import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect } from "react";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import classes from './style.module.scss';

export const TicketOrder = props => {
    useStyles(classes)
    const {intl, history, order, ticket} = props

    return (
        <div className={classes.SelectedOrderBox} onClick={() => history.push({pathname: `/user/support/order`,state:{from:'ticketadd'}})}>
            <div className={classes.OrderNo}>
                {intl.formatMessage({id:"order_no"})}
                <span>
                    { order?.id || ticket?.operaId || '-'}
                </span>
            </div>
            <div className={classes.OrderCreateTime}>
                {intl.formatMessage({id:"payment_time"})}
                <span>
                    {
                        order?.orderTime ?
                        (new Date(order.orderTime).toLocaleDateString() + " " + new Date(order.orderTime).toTimeString().substr(0, 5)):
                        ticket?.openDate?
                        (new Date(ticket.openDate).toLocaleDateString() + " " + new Date(ticket.openDate).toTimeString().substr(0, 5)):
                        '-'
                    }
                </span>
            </div>
            <Iconfont className={classes.ChangeOrder}>&#xe66b;</Iconfont>
        </div>
    )
}